export const initialState = {
	jobLines: [],
	totalCount: undefined,
	isLoadingJobLines: false,
	isLoadedJobLines: false,
	loadJobLinesErrorMessage: undefined
};

export default { initialState };
